import React, { useState, useEffect } from 'react';

function TimerComponent(props) {

    const [time, setTime] = useState(10 * 60); // 10 minutos em segundos

    useEffect(() => {
        const timerInterval = setInterval(() => {
            setTime(prevTime => prevTime > 0 ? prevTime - 1 : 0);
        }, 1000);

        return () => clearInterval(timerInterval);
    }, []);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    };

    useEffect(() => {
        if (time === 0) {
            alert("O tempo para pagamento expirou.");
        }
    }, [time]);

    return (

        <div className="timer" style={{ fontSize: '2rem', fontWeight: 'bold', textAlign: 'center', marginTop: '20px' }}>
            {formatTime(time)}
        </div>

    );
};

export default TimerComponent;
